import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark3 border-t border-brand-border py-10 px-5" data-id="element-89">
      <div className="max-w-[860px] mx-auto" data-id="element-90">
        <div className="text-center mb-7" data-id="element-91">
          <h3 className="text-lg font-black text-white mb-1" data-id="element-92">
            CERO ATRASOS — Plan de 21 Días
          </h3>
          <p className="text-xs text-brand-gray" data-id="element-93">
            El Método 4C: Corta · Clasifica · Calendariza · Cierra
          </p>
          <p className="text-[11px] text-[#555] mt-1.5" data-id="element-94">
            Para Trabajadores con Ingresos Variables en Estados Unidos
          </p>
        </div>

        <div className="text-center mt-6 text-[11px] text-[#555]" data-id="element-95">
          <p data-id="element-96">© 2025 CERO ATRASOS — Todos los derechos reservados.</p>
          <p className="mt-1" data-id="element-97">
            Producto digital — Entrega inmediata tras la compra
          </p>
        </div>
      </div>
    </footer>;
}